import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Row } from "reactstrap";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import CustomDatePickerV2 from "views/pages/manage/common/commonComponents/CustomDatePicker-V2";
import moment from "moment";
import { labelStyles } from "../constants";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import { getFilterCount } from "../../../edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import { ignoreFilterItem } from '../constants';
import { regex } from 'views/pages/manage/common/constant';
import { FaCheckSquare } from 'react-icons/fa';

const FilterForm = ({
  closePopup,
  dropdownData,
  globalFilter,
  setGlobalFilter,
  filterCount,
  setFilterCount,
  applyFilterHandler,
}) => {
  const [filterForm,setFilterForm] = useState(globalFilter)
  // apply filter callback
  const handleApplyFilter = () => {
    let fCount = getFilterCount({ ...filterForm }, ignoreFilterItem);
    setFilterCount(fCount);
    //call search api
    applyFilterHandler(filterForm);
    setGlobalFilter(filterForm)
    closePopup();
  };

  //reset filter form
  const resetFilterForm = () => {
    setFilterCount(0);
    setGlobalFilter({});
    //call api to fetch list
    applyFilterHandler({});
    closePopup();
  };

  // works as onChange Handler
  const filterFormHandler = (key, value) => {
    setFilterForm((prev) => ({ ...prev, [key]: value ?? [] }));
    // setGlobalFilter((prev) => ({ ...prev, [key]: value ?? [] }));
  };


  return (
    <Card className="mb-0 regular-body label-color"
      style={{ width: "500px", borderRadius: "12px" }}>
      <CardBody className="d-flex flex-column">
        <div className="mb-1 d-flex align-items-start justify-content-between">
          <div className="regular-large-bold">Filters</div>
        </div>

        <div className="d-flex flex-column gap-md">
          <Row>
            <Col md={6}>
              <AAutoComplete
                label="Status"
                currentValue={filterForm?.status}
                items={dropdownData?.schoolStatus}
                handleChange={(value) => {
                  filterFormHandler("status", value);
                }}
                selectAllMenuButton={true}
                isShowCount={true}
                isMulti={true}
              />
            </Col>
            <Col md={6}>
              <AAutoComplete
                label="Country*"
                currentValue={filterForm?.country}
                items={dropdownData?.allcountry}
                handleChange={(value) => {
                  filterFormHandler("country", value);
                }}
                selectAllMenuButton={true}
                isShowCount={true}
                isMulti={true}
              />
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <AAutoComplete
                label="Branch"
                currentValue={filterForm?.mappedBranchIds}
                items={dropdownData?.allBusinessArea}
                handleChange={(value) => {
                  filterFormHandler("mappedBranchIds", value);
                }}
                selectAllMenuButton={true}
                isShowCount={true}
                isMulti={true}
              />
            </Col>
            <Col md={6}>
              {/* <AAutoComplete
                label="Region*"
                currentValue={filterForm?.region}
                items={dropdownData?.allRegion}
                handleChange={(value) => {
                  filterFormHandler("region", value);
                }}
                selectAllMenuButton={true}
                isShowCount={true}
                isMulti={true}
              /> */}
               <AAutoComplete
                label="Board"
                currentValue={filterForm?.board}
                items={dropdownData?.board}
                handleChange={(value) => {
                  filterFormHandler("board", value);
                }}
                selectAllMenuButton={true}
                isShowCount={true}
                isMulti={true}
              />
            </Col>
          </Row>

          <Row>
            <Col md={6}>
            <AAutoComplete
                label="State*"
                currentValue={filterForm?.state}
                items={dropdownData?.allState}
                handleChange={(value) => {
                  filterFormHandler("state", value);
                }}
                selectAllMenuButton={true}
                isShowCount={true}
                isMulti={true}
              />
            </Col>
            <Col md={6}>
            <AInput
                type="text"
                label="Pincode"
                value={filterForm?.pincode} // Dynamically access value
                handler={(value) => {
                  filterFormHandler( 'pincode', value)
                }}
                maxLength={6}
                placeholder="Enter"
                //style={selectStyles.control}
                regex={regex?.numeric}
                //onClick={()=>{validatePincode(basicForm[col?.colKey])}}
                //style={inputStyle}
              />
            </Col>
          </Row>

          <div className="mt-3 d-flex flex-row-reverse justify-content-between">
            <AButton
              variant="primary_filled"
              className="button_remove_left_margin"
              onClick={() => {
                handleApplyFilter();
              }}
              disabled={!getFilterCount({ ...filterForm }, ignoreFilterItem) || !(filterForm?.country?.length && filterForm?.state?.length)}
            >
              Apply
            </AButton>

            {filterCount > 0 && (
              <AButton
                variant="danger_filled"
                className="button_remove_left_margin"
               // updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
                onClick={resetFilterForm}
              >
                Reset
              </AButton>
            )}
          </div>
        </div>
      </CardBody>
    </Card>
  )
}

export default FilterForm;